<template>
    <b-col class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm bộ phận sử dụng</strong>
                    </div>

                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" :excluded="[2]" v-model="searchForm.syncSourceType" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Đơn vị trực thuộc: "
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" id="unitTree"></unit-tree>-->
                                    <unit-tree ref="unitTree"
                                               v-model="searchForm.unitId"
                                               :cached="true">
                                    </unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Mã/Tên bộ phận sử dụng: "
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="search"
                                                  placeholder="Nhập tên hoặc mã ..."
                                                  v-model="searchForm.str">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label=""
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>


                    <b-grid-tree :searchForm="searchForm"
                                 :gridOptions="gridOptions"
                                 dataUrl="master-data/departments"
                                 gridName="Danh sách bộ phận sử dụng"
                                 ref="departmentTable">
                        <template v-slot:actions v-if="authorize(['ManageDepartment'])">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template v-if="authorize(['ViewDepartment'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/detail`}" title="xem" variant="info">
                                        Xem
                                    </b-button>
                                </template>
                                <template v-if="authorize(['ManageDepartment'])">
                                    <b-button size="sm" tag="button" variant="primary"
                                              :to="{ path: `./${row.item.id}/edit` }" title="sửa" class="mr5">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageDepartment'])" size="sm" @click.stop="remove(row.item.id, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid-tree>
                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListDepartment',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    str: null,
                    unitId: null,
                    syncSourceType: this.getSyncSourceTypeCache(null, [2]),
                },
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã bộ phận sử dụng', sortable: true, sortDirection: 'asc' },
                        { key: 'name', label: 'Tên bộ phận sử dụng', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'unitName', label: 'Đơn vị trực thuộc', sortable: true },
                        { key: 'address', label: 'Địa chỉ', sortable: true },
                        { key: 'phoneNumber', label: 'Số điện thoại', sortable: true },
                        { key: 'fax', label: 'Fax', sortable: true },
                    ],
                    sortBy: 'code'
                },
            }
        },
        watch: {
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.departmentTable.refresh();
            },
            remove(id) {
                var vm = this;
                if (id) {
                    if (confirm('Bạn có chắc chắn muốn xóa bộ phận sử dụng này?')) {
                        this.$services.delete(`master-data/departments/${id}`).done((response) => {
                            vm.$toastr.s('Xóa nhóm tài sản thành công !');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn bộ phận sử dụng cần xóa');
                }
            },
        }
    }
</script>
<!--scoped-->
<style>

    #unitTree #unit {
        z-index: 99999
    }

    .isActive {
        color: #f11d1d;
        font-style: italic;
    }
</style>
